import { CodeDividers, WidgetType } from 'common/types/code'
import { LocalNodesPinned } from 'common/types/model'

export const getNodesFromLocalStorage = (
  appId: string,
  companyId: number,
  appName: string
): {
  existNodeForCurrent?: LocalNodesPinned
  existNodeForCurrentIndex: number
  nodes: LocalNodesPinned[]
} => {
  const nodesFromLocalStorage = localStorage.getItem('nodesPinned')
  if (nodesFromLocalStorage) {
    const nodes: LocalNodesPinned[] = JSON.parse(nodesFromLocalStorage)
    let existNodeForCurrent = nodes.find(
      (node) => node.appId === appId && node.companyId === companyId && node.appName === appName
    )
    let existNodeForCurrentIndex = nodes.findIndex(
      (node) => node.appId === appId && node.companyId === companyId && node.appName === appName
    )
    return { existNodeForCurrent, existNodeForCurrentIndex, nodes }
  }
  return { existNodeForCurrent: undefined, existNodeForCurrentIndex: -1, nodes: [] }
}
export type PaneNode = {
  type: 'pane'
  key: string
  splitPane?: { split: 'horizontal' | 'vertical' }
  dividerKey?: CodeDividers
  defaultDividerSize?: number
  children?: Array<PaneNode | WidgetNode>
}

type WidgetNode = {
  type: 'widget'
  key: string
  contentType: WidgetType
  dividerKey?: CodeDividers
  defaultDividerSize?: number
}
export const buildDiagramAndDocsOnly = (): PaneNode => {
  return {
    type: 'pane',
    key: 'root',
    splitPane: { split: 'vertical' },
    children: [
      {
        type: 'pane',
        key: 'pane-left',
        splitPane: { split: 'horizontal' },
        dividerKey: CodeDividers.LEFT_PANE_DIVIDER,
        defaultDividerSize: 50,
        children: [
          {
            type: 'widget',
            key: 'w-diagram',
            contentType: WidgetType.DIAGRAM,
            dividerKey: CodeDividers.DIAGRAM_DIVIDER,
            defaultDividerSize: 100
          }
        ]
      },
      {
        type: 'pane',
        key: 'pane-right',
        splitPane: { split: 'horizontal' },
        dividerKey: CodeDividers.RIGHT_PANE_DIVIDER,
        defaultDividerSize: 50,
        children: [
          {
            type: 'widget',
            key: 'w-docs',
            contentType: WidgetType.DOCS,
            dividerKey: CodeDividers.DOCS_DIVIDER,
            defaultDividerSize: 100
          }
        ]
      }
    ]
  }
}
export const buildWidgets_AiLeft_Layout1 = (isPreview: boolean): PaneNode => {
  return {
    type: 'pane',
    key: 'root',
    splitPane: { split: 'vertical' },
    children: [
      {
        type: 'pane',
        key: 'pane-left',
        splitPane: { split: 'horizontal' },
        dividerKey: CodeDividers.LEFT_PANE_DIVIDER,
        defaultDividerSize: 50,
        children: [
          {
            type: 'widget',
            key: 'w-code-ai',
            contentType: WidgetType.CODE_AI_HELPER,
            dividerKey: CodeDividers.CODE_AI_HELPER_DIVIDER,
            defaultDividerSize: 50
          },
          {
            type: 'widget',
            key: 'w-diagram',
            contentType: WidgetType.DIAGRAM,
            dividerKey: CodeDividers.DIAGRAM_DIVIDER,
            defaultDividerSize: 50
          }
        ]
      },
      {
        type: 'pane',
        key: 'pane-right',
        splitPane: { split: 'horizontal' },
        dividerKey: CodeDividers.RIGHT_PANE_DIVIDER,
        defaultDividerSize: 50,
        children: [
          {
            type: 'widget',
            key: 'w-result-or-preview',
            contentType: isPreview ? WidgetType.PREVIEW : WidgetType.RESULT,
            dividerKey: isPreview ? CodeDividers.PREVIEW_DIVIDER : CodeDividers.RESULT_DIVIDER,
            defaultDividerSize: 50
          },
          {
            type: 'widget',
            key: 'w-docs',
            contentType: WidgetType.DOCS,
            dividerKey: CodeDividers.DOCS_DIVIDER,
            defaultDividerSize: 50
          }
        ]
      }
    ]
  }
}
export const buildWidgets_AiLeft_Layout2 = (isPreview: boolean): PaneNode => {
  return {
    type: 'pane',
    key: 'root',
    splitPane: { split: 'vertical' },
    children: [
      {
        type: 'pane',
        key: 'pane-left',
        splitPane: { split: 'horizontal' },
        dividerKey: CodeDividers.LEFT_PANE_DIVIDER,
        defaultDividerSize: 50,
        children: [
          {
            type: 'widget',
            key: 'w-code-ai',
            contentType: WidgetType.CODE_AI_HELPER,
            dividerKey: CodeDividers.CODE_AI_HELPER_DIVIDER,
            defaultDividerSize: 50
          },
          {
            type: 'widget',
            key: 'w-diagram',
            contentType: WidgetType.DIAGRAM,
            dividerKey: CodeDividers.DIAGRAM_DIVIDER,
            defaultDividerSize: 50
          }
        ]
      },
      {
        type: 'pane',
        key: 'pane-right',
        splitPane: { split: 'horizontal' },
        dividerKey: CodeDividers.RIGHT_PANE_DIVIDER,
        defaultDividerSize: 50,
        children: [
          {
            type: 'widget',
            key: 'w-code',
            contentType: WidgetType.CODE,
            dividerKey: CodeDividers.CODE_DIVIDER,
            defaultDividerSize: 50
          },
          {
            type: 'widget',
            key: 'w-result-or-preview',
            contentType: isPreview ? WidgetType.PREVIEW : WidgetType.RESULT,
            dividerKey: isPreview ? CodeDividers.PREVIEW_DIVIDER : CodeDividers.RESULT_DIVIDER,
            defaultDividerSize: 50
          }
        ]
      }
    ]
  }
}
export const buildWidgets_AiRight_Layout1 = (isPreview: boolean): PaneNode => {
  return {
    type: 'pane',
    key: 'root',
    splitPane: { split: 'vertical' },
    children: [
      {
        type: 'pane',
        key: 'pane-left',
        splitPane: { split: 'horizontal' },
        dividerKey: CodeDividers.LEFT_PANE_DIVIDER,
        defaultDividerSize: 50,
        children: [
          {
            type: 'widget',
            key: 'w-diagram',
            contentType: WidgetType.DIAGRAM,
            dividerKey: CodeDividers.DIAGRAM_DIVIDER,
            defaultDividerSize: 100
          }
        ]
      },
      {
        type: 'pane',
        key: 'pane-right',
        splitPane: { split: 'horizontal' },
        dividerKey: CodeDividers.RIGHT_PANE_DIVIDER,
        defaultDividerSize: 50,
        children: [
          {
            type: 'widget',
            key: 'w-code-ai',
            contentType: WidgetType.CODE_AI_HELPER,
            dividerKey: CodeDividers.CODE_AI_HELPER_DIVIDER,
            defaultDividerSize: 40
          },
          {
            type: 'widget',
            key: 'w-result-or-preview',
            contentType: isPreview ? WidgetType.PREVIEW : WidgetType.RESULT,
            dividerKey: isPreview ? CodeDividers.PREVIEW_DIVIDER : CodeDividers.RESULT_DIVIDER,
            defaultDividerSize: 40
          },
          {
            type: 'widget',
            key: 'w-docs',
            contentType: WidgetType.DOCS,
            dividerKey: CodeDividers.DOCS_DIVIDER,
            defaultDividerSize: 20
          }
        ]
      }
    ]
  }
}
export const buildWidgets_AiRight_Layout2 = (isPreview: boolean): PaneNode => {
  return {
    type: 'pane',
    key: 'root',
    splitPane: { split: 'vertical' },
    children: [
      {
        type: 'pane',
        key: 'pane-left',
        splitPane: { split: 'horizontal' },
        dividerKey: CodeDividers.LEFT_PANE_DIVIDER,
        defaultDividerSize: 50,
        children: [
          {
            type: 'widget',
            key: 'w-diagram',
            contentType: WidgetType.DIAGRAM,
            dividerKey: CodeDividers.DIAGRAM_DIVIDER,
            defaultDividerSize: 100
          }
        ]
      },
      {
        type: 'pane',
        key: 'pane-right',
        splitPane: { split: 'horizontal' },
        dividerKey: CodeDividers.RIGHT_PANE_DIVIDER,
        defaultDividerSize: 50,
        children: [
          {
            type: 'widget',
            key: 'w-code-ai',
            contentType: WidgetType.CODE_AI_HELPER,
            dividerKey: CodeDividers.CODE_AI_HELPER_DIVIDER,
            defaultDividerSize: 20
          },
          {
            type: 'widget',
            key: 'w-code',
            contentType: WidgetType.CODE,
            dividerKey: CodeDividers.CODE_DIVIDER,
            defaultDividerSize: 40
          },
          {
            type: 'widget',
            key: 'w-result-or-preview',
            contentType: isPreview ? WidgetType.PREVIEW : WidgetType.RESULT,
            dividerKey: isPreview ? CodeDividers.PREVIEW_DIVIDER : CodeDividers.RESULT_DIVIDER,
            defaultDividerSize: 40
          }
        ]
      }
    ]
  }
}
export const buildDiagramAndResultWithoutBot = (isPreview: boolean): PaneNode => {
  return {
    type: 'pane',
    key: 'root',
    splitPane: { split: 'vertical' },
    children: [
      {
        type: 'pane',
        key: 'pane-left',
        splitPane: { split: 'horizontal' },
        dividerKey: CodeDividers.LEFT_PANE_DIVIDER,
        defaultDividerSize: 50,
        children: [
          {
            type: 'widget',
            key: 'w-diagram',
            contentType: WidgetType.DIAGRAM,
            dividerKey: CodeDividers.DIAGRAM_DIVIDER,
            defaultDividerSize: 100
          }
        ]
      },
      {
        type: 'pane',
        key: 'pane-right',
        splitPane: { split: 'horizontal' },
        dividerKey: CodeDividers.RIGHT_PANE_DIVIDER,
        defaultDividerSize: 50,
        children: [
          {
            type: 'widget',
            key: 'w-result-or-preview',
            contentType: isPreview ? WidgetType.PREVIEW : WidgetType.RESULT,
            dividerKey: isPreview ? CodeDividers.PREVIEW_DIVIDER : CodeDividers.RESULT_DIVIDER,
            defaultDividerSize: 50
          },
          {
            type: 'widget',
            key: 'w-docs',
            contentType: WidgetType.DOCS,
            dividerKey: CodeDividers.DOCS_DIVIDER,
            defaultDividerSize: 50
          }
        ]
      }
    ]
  }
}
export const buildDiagramAndCodeWithoutBot = (isPreview: boolean): PaneNode => {
  return {
    type: 'pane',
    key: 'root',
    splitPane: { split: 'vertical' },
    children: [
      {
        type: 'pane',
        key: 'pane-left',
        splitPane: { split: 'horizontal' },
        dividerKey: CodeDividers.LEFT_PANE_DIVIDER,
        defaultDividerSize: 50,
        children: [
          {
            type: 'widget',
            key: 'w-diagram',
            contentType: WidgetType.DIAGRAM,
            dividerKey: CodeDividers.DIAGRAM_DIVIDER,
            defaultDividerSize: 100
          }
        ]
      },
      {
        type: 'pane',
        key: 'pane-right',
        splitPane: { split: 'horizontal' },
        dividerKey: CodeDividers.RIGHT_PANE_DIVIDER,
        defaultDividerSize: 50,
        children: [
          {
            type: 'widget',
            key: 'w-code',
            contentType: WidgetType.CODE,
            dividerKey: CodeDividers.CODE_DIVIDER,
            defaultDividerSize: 50
          },
          {
            type: 'widget',
            key: 'w-result-or-preview',
            contentType: isPreview ? WidgetType.PREVIEW : WidgetType.RESULT,
            dividerKey: isPreview ? CodeDividers.PREVIEW_DIVIDER : CodeDividers.RESULT_DIVIDER,
            defaultDividerSize: 50
          }
        ]
      }
    ]
  }
}
export const buildNoNodeWithDiagramAndDocsWidgetsAiLeft = (): PaneNode => {
  return {
    type: 'pane',
    key: 'root',
    splitPane: { split: 'vertical' },
    children: [
      {
        type: 'pane',
        key: 'pane-left',
        splitPane: { split: 'horizontal' },
        dividerKey: CodeDividers.LEFT_PANE_DIVIDER,
        defaultDividerSize: 50,
        children: [
          {
            type: 'widget',
            key: 'w-code-ai',
            contentType: WidgetType.CODE_AI_HELPER,
            dividerKey: CodeDividers.CODE_AI_HELPER_DIVIDER,
            defaultDividerSize: 50
          },
          {
            type: 'widget',
            key: 'w-diagram',
            contentType: WidgetType.DIAGRAM,
            dividerKey: CodeDividers.DIAGRAM_DIVIDER,
            defaultDividerSize: 50
          }
        ]
      },
      {
        type: 'pane',
        key: 'pane-right',
        splitPane: { split: 'horizontal' },
        dividerKey: CodeDividers.RIGHT_PANE_DIVIDER,
        defaultDividerSize: 50,
        children: [
          {
            type: 'widget',
            key: 'w-docs',
            contentType: WidgetType.DOCS,
            dividerKey: CodeDividers.DOCS_DIVIDER,
            defaultDividerSize: 100
          }
        ]
      }
    ]
  }
}

export const buildNoNodeWithDiagramAndDocsWidgetsAiRight = (): PaneNode => {
  return {
    type: 'pane',
    key: 'root',
    splitPane: { split: 'vertical' },
    children: [
      {
        type: 'pane',
        key: 'pane-left',
        splitPane: { split: 'horizontal' },
        dividerKey: CodeDividers.LEFT_PANE_DIVIDER,
        defaultDividerSize: 50,
        children: [
          {
            type: 'widget',
            key: 'w-diagram',
            contentType: WidgetType.DIAGRAM,
            dividerKey: CodeDividers.DIAGRAM_DIVIDER,
            defaultDividerSize: 100
          }
        ]
      },
      {
        type: 'pane',
        key: 'pane-right',
        splitPane: { split: 'horizontal' },
        dividerKey: CodeDividers.RIGHT_PANE_DIVIDER,
        defaultDividerSize: 50,
        children: [
          {
            type: 'widget',
            key: 'w-code-ai',
            contentType: WidgetType.CODE_AI_HELPER,
            dividerKey: CodeDividers.CODE_AI_HELPER_DIVIDER,
            defaultDividerSize: 50
          },
          {
            type: 'widget',
            key: 'w-docs',
            contentType: WidgetType.DOCS,
            dividerKey: CodeDividers.DOCS_DIVIDER,
            defaultDividerSize: 50
          }
        ]
      }
    ]
  }
}
